// Style
import "../assets/scss/main.scss";

// Moduły
import { initFooterAccordion } from "./modules/footer-accordion";

initFooterAccordion();
